import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ic_model",
  "use": "icon-ic_model-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ic_model\">\r\n\t<path d=\"M922.72 238.4L542.624 17.696a61.216 61.216 0 0 0-61.248 0L101.248 238.432a61.216 61.216 0 0 0-30.336 52.736V732.8a61.248 61.248 0 0 0 30.368 52.768l380.096 220.704a61.184 61.184 0 0 0 61.248-0.032l380.128-220.704a61.216 61.216 0 0 0 30.336-52.736V291.168a61.216 61.216 0 0 0-30.368-52.768zM513.504 950.944L134.912 732.8 133.408 293.76 512 73.92 889.088 291.2l1.504 439.072z\" p-id=\"40081\">\r\n\t</path>\r\n\t<path d=\"M774.656 325.216l-260.16 150.176-265.152-153.088a32 32 0 1 0-32 55.424l260.128 150.176v306.24a32 32 0 0 0 64 0V533.76l265.184-153.12a32 32 0 1 0-32-55.424z\" p-id=\"40082\">\r\n\t</path>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ic_model.svg
// module id = XpY0
// module chunks = 15